export default Object.freeze({
  sanitizeSettings: {
    allowedTags: ['a', 'div', 'br', 'p', 'strong', 'em'],
    allowedAttributes: {
      a: ['href', 'target'],
    },
  },
});
